import React, { useState } from "react";
import {
  faArrowRight,
  faPenToSquare,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import Action_Btn from "../Common_Btn/Action_Btn/Action_Btn";
import "./CommonSelectAddress.css";
import {
  deleteAddress,
  getAllOrderAddress,
  getAllSippingOrderAddress,
  getSingleOrderAddress,
} from "../../../features/order/orderSlice";
import EditAddressModal from "../Common_Modal/AddAddressModal/EditAddressModal";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

const CommonSelectAddress = ({ Data, isChange }) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [data, setData] = useState(false);
  const dispatch = useDispatch();
  const GetData = async (id) => {
    try {
      const res = await dispatch(getSingleOrderAddress(id));

      setData(res?.payload?.data);
      setShowEditModal(true);
      // dispatch(getSingleOrderAddress(id));
    } catch (error) {}
  };

    // useEffect(() => {
    //   GetData(Data?.id);
    //   }, [Data]);

  const deletSubmit = async (data) => {
    // if()

    const res = await dispatch(deleteAddress(data));
    dispatch(getAllOrderAddress());
    dispatch(getAllSippingOrderAddress());
    // if (res?.payload?.errors) {
    //     setError("pincode", {
    //         type: "manual",
    //         message: res.payload?.errors,
    //       });
    //   }else{
    //     setshowUploadModal(true);
    //   }
  };
  return (
    <section className="CommonSelectAddress">
      <div className="address_text_div">
        <div className="top_text_div">
          <p className="owner_name">Pratiksha</p>

          {isChange ? (
            <div
              className="change_div"
              onClick={() => {
                GetData(Data?.id);
              }}
            >
              <p className="change_text">Change</p>
            </div>
          ) : (
            <div className="action_btn_holder">
              <div className="delete_btn" onClick={() => deletSubmit(Data?.id)}>
                <Action_Btn btn_name="Delete" icon={faTrash} />
              </div>

              <div
                className="edit_btn"
                onClick={() => {
                  GetData(Data?.id);
                }}
              >
                <Action_Btn btn_name="Edit" icon={faPenToSquare} />
              </div>
            </div>
          )}
        </div>

        <div className="address_holder">
          <p className="address">
            {Data?.company_name}, {Data?.address_one}, {Data?.address_two},{" "}
            {Data?.Country?.name}, {Data?.State?.name}, {Data?.City?.name}{" "}
            {Data?.Pincode?.name}
          </p>
        </div>
      </div>

      <EditAddressModal
        data={data}
        show={showEditModal}
        // GetData={GetData}
        onHide={() => {
          setShowEditModal(false);
        }}
      />
    </section>
  );
};

export default CommonSelectAddress;
